import React, { useState, useRef, useEffect } from 'react';
import { ArrowDownUp, ArrowUp, ArrowDown, ChevronDown } from 'lucide-react';

const SortControl = ({ sortBy, sortDir, onChange, options }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const currentLabel = options.find(o => o.key === sortBy)?.label || 'Trier';

  const handleSelect = (key) => {
    if (key === sortBy) {
      onChange(sortBy, sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      onChange(key, 'asc');
    }
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(v => !v)}
        className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 text-white px-4 py-2 rounded-lg border border-gray-700 text-sm font-semibold transition-colors h-full"
      >
        {sortDir === 'asc' ? <ArrowUp size={15} className="text-blue-400" /> : <ArrowDown size={15} className="text-blue-400" />}
        <span className="hidden sm:inline">{currentLabel}</span>
        <ChevronDown size={13} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-xl shadow-2xl z-50 overflow-hidden">
          {options.map(opt => (
            <button
              key={opt.key}
              onClick={() => handleSelect(opt.key)}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-sm text-left transition-colors hover:bg-gray-700 ${sortBy === opt.key ? 'text-blue-400 font-semibold bg-gray-700/50' : 'text-gray-300'}`}
            >
              <span>{opt.label}</span>
              {sortBy === opt.key && (sortDir === 'asc' ? <ArrowUp size={13} /> : <ArrowDown size={13} />)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortControl;
